(() => {
  'use strict';

  const desktopQuery = window.matchMedia('(min-width: 1001px)');
  let retryTimer = null;

  const directChild = (element, selector) =>
    Array.from(element.children).find(child => child.matches(selector));

  const directMainLink = item =>
    Array.from(item.children).find(child =>
      child.tagName === 'A' &&
      !child.classList.contains('toggle') &&
      !child.classList.contains('toggle-back') &&
      !child.classList.contains('toggle-wide')
    );

  const overviewLink = item => {
    const dropdown = directChild(item, 'ul');
    if (!dropdown) return null;

    const firstContentColumn = Array.from(dropdown.children).find(child =>
      child.tagName === 'LI' &&
      !child.classList.contains('fidello-species-tabs')
    );
    const firstColumnPageLink = firstContentColumn?.querySelector(
      ':scope > ul > li:first-child > a[href*="/pages/"]'
    );
    if (firstColumnPageLink) return firstColumnPageLink;

    return Array.from(dropdown.querySelectorAll('a[href*="/pages/"]')).find(link =>
      !link.classList.contains('fidello-species-tabs__link')
    );
  };

  const menuList = () => {
    const lists = Array.from(document.querySelectorAll(
      '#nav > ul:not(.inner):not(.nav-user):not(.nav-top), #nav-bar > ul'
    ));
    return lists.find(list => window.getComputedStyle(list).display !== 'none');
  };

  const restoreMobile = () => {
    document.documentElement.classList.remove('fidello-menu-ready');
    document.querySelectorAll('.fidello-species-tabs').forEach(row => row.remove());
    document.querySelectorAll('.fidello-species-enhanced').forEach(dropdown => {
      dropdown.classList.remove('fidello-species-enhanced');
      Array.from(dropdown.classList)
        .filter(name => name.startsWith('fidello-species-cols-'))
        .forEach(name => dropdown.classList.remove(name));
    });
    document.querySelectorAll('.fidello-species-overview-duplicate').forEach(item =>
      item.classList.remove('fidello-species-overview-duplicate')
    );
    document.querySelectorAll('[data-fidello-full-title]').forEach(link => {
      link.removeAttribute('data-fidello-full-title');
      link.removeAttribute('aria-label');
      link.removeAttribute('title');
    });
  };

  const enhance = () => {
    if (!desktopQuery.matches) {
      restoreMobile();
      return true;
    }

    const list = menuList();
    if (!list) return false;

    const candidates = Array.from(list.children).filter(item =>
      item.tagName === 'LI' &&
      directMainLink(item) &&
      directChild(item, 'ul')
    );
    if (candidates.length < 4) return false;

    const species = candidates.slice(0, 4);
    species.forEach(item => {
      directChild(item, 'ul')
        ?.querySelector(':scope > .fidello-species-tabs')
        ?.classList.remove('fidello-species-overview-duplicate');
    });

    const data = species.map((item, index) => {
      const mainLink = directMainLink(item);
      const dropdown = directChild(item, 'ul');
      const pageLink = overviewLink(item);
      const fullLabel = mainLink.querySelector('.fidello-top-label__full');
      const fullTitle = mainLink.dataset.fidelloFullTitle || fullLabel?.textContent.trim() || mainLink.textContent.trim();

      mainLink.dataset.fidelloFullTitle = fullTitle;
      mainLink.setAttribute('aria-label', fullTitle);
      mainLink.setAttribute('title', fullTitle);
      if (pageLink) {
        pageLink.closest('li')?.classList.add('fidello-species-overview-duplicate');
      }

      return {
        dropdown,
        fullTitle,
        url: pageLink?.getAttribute('href') || mainLink.getAttribute('href') || '/'
      };
    });

    document.documentElement.classList.add('fidello-menu-ready');

    data.forEach((current, activeIndex) => {
      if (!current.dropdown || current.dropdown.classList.contains('fidello-species-enhanced')) return;

      const row = document.createElement('li');
      row.className = 'fidello-species-tabs';
      const nav = document.createElement('nav');
      nav.className = 'fidello-species-tabs__nav';
      nav.setAttribute('aria-label', current.fullTitle);

      data.forEach((entry, index) => {
        const link = document.createElement('a');
        link.className = 'fidello-species-tabs__link';
        link.href = entry.url;
        link.textContent = entry.fullTitle;
        if (index === activeIndex) link.setAttribute('aria-current', 'true');
        nav.append(link);
      });

      const columnCount = Array.from(current.dropdown.children)
        .filter(child => child.tagName === 'LI').length;
      row.append(nav);
      current.dropdown.prepend(row);
      current.dropdown.classList.add(
        'fidello-species-enhanced',
        `fidello-species-cols-${columnCount}`
      );
    });

    return true;
  };

  const stopRetry = () => {
    if (!retryTimer) return;
    window.clearInterval(retryTimer);
    retryTimer = null;
  };

  const start = () => {
    if (enhance()) {
      stopRetry();
      return;
    }
    if (retryTimer) return;

    let attempts = 0;
    retryTimer = window.setInterval(() => {
      attempts += 1;
      if (enhance() || attempts >= 100) stopRetry();
    }, 50);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('load', start, { once: true });
  window.addEventListener('pageshow', start);
  window.addEventListener('popstate', start);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) start();
  });

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', event => {
      if (event.matches) start();
      else restoreMobile();
    });
  }

  document.addEventListener('shopify:section:load', start);
})();
